import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import get from 'lodash/get';
import Button from 'react-bootstrap-button-loader';
import { setLoader, removeLoader } from '../../../../actions';
import { SspApi } from '../../../../api';

import {
  InputField,
  RadioField,
  SelectField,
  required,
  url
} from '../../../../components/form';

class Basic extends Component {

  onFormSubmit(vals) {
    const {
      dispatch,
      website,
      websites
    } = this.props;

    dispatch(setLoader('BasicSettingsForm'));
    dispatch(SspApi.actions.websiteUpdate.post(website.uuid, vals, (error, success) => {
      dispatch(removeLoader('BasicSettingsForm'));
      if (success) {
        const collection = [...websites.data].map((obj) => {
          return obj.uuid === success.data.uuid ? success.data : obj;
        });

        if (success.data.uuid) {
          dispatch(SspApi.actions.pixel.get({ ssp_website_id: website.uuid }));
        }

        dispatch({
          type: SspApi.events.websites.actionSuccess,
          syncing: false,
          data: { ...websites, data: collection, meta: { ...websites.meta } }
        });
      }
    }));
  }

  render() {
    const { handleSubmit, isLoading } = this.props;
    return (
      <div className='ibox'>
        <div className='ibox-title'>
          <h5>General Settings</h5>      
        </div>
        <div className='ibox-content'>
          <form 
            onSubmit={handleSubmit(this.onFormSubmit.bind(this))} 
            className='m-t'
          >
            <h4 style={{ fontSize: 13 }}>Website Settings</h4>
            <hr />
            <Field
              type='text'
              name='website[name]'
              placeholder='Name of your website'
              label='Name'
              component={InputField}
              validate={[required]}
            />
            <Field
              type='text'
              name='website[url]'
              placeholder='URL of your website'
              label='URL'
              component={InputField}
              validate={[required, url]}
            />
            <br />
            <h4 style={{ fontSize: 13 }}>Ad Exchange Settings</h4>
            <hr />
            <Field
              type='number'
              name='website[jdx_min_cpc]'
              placeholder='Minimum cpc for the ad slots'
              label='Ad Min CPC'
              component={InputField}
              validate={[required]}
            />
            <Field
              type='number'
              name='website[jdx_min_cpa]'
              placeholder='Minimum cpa for the ad slots'
              label='Ad Min CPA'
              component={InputField}
              validate={[required]}
            />
            <Field 
              name='website[jdx_backfill]'
              label="Ad CPA Backfill"
              options={[['true', 'Enable'], ['false', 'Disable']]}
              component={RadioField}
            />

            <div className='text-right'>
              <Button
                type='submit'
                loading={isLoading}
                bsStyle='primary'
              >
                Update
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'BasicSettingsForm'
});

const mapStateToProps = (state, ownProps) => {
  const { loader } = state;
  const isLoading = loader.includes('BasicSettingsForm');
  const website = get(ownProps, 'website', {});
  const websites = get(state, 'ssp.websites.data', {});

  const initialValues = {
    website: {
      name: website.name,
      url: website.url,
      jdx_min_cpc: website.jdx_min_cpc,
      jdx_min_cpa: website.jdx_min_cpa,
      jdx_backfill: (website.jdx_backfill || false).toString()
    }
  };

  return { isLoading, initialValues, websites };
};

export default connect(mapStateToProps)(ResourceForm(Basic));
